import styled from "styled-components";

export const BannerWrapper = styled.div`
  padding: 95px 20px 0;
  @media (max-width: 1199px) {
    padding: 90px 0 0;
  }
  @media (max-width: 899px) {
    padding: 85px 0 0;
  }
  @media (max-width: 599px) {
    padding: 75px 0 0;
  }
  &.about_banner {
    .bannerInner {
      figure {
        background: rgb(6, 13, 17);
        img {
          object-fit: contain;
        }
      }
    }
  }
  &.banner_main {
    .banner_text {
      h1 {
        max-width: 661px;
        margin: 0 auto;
      }
    }
  }
  .bannerInner {
    position: relative;
    border-radius: 25px;
    overflow: hidden;
    padding: 218px 0 203px;
    min-height: 637px;
    @media (max-width: 1199px) {
      border-radius: 0;
    }
    @media (max-width: 1199px) {
      min-height: auto;
      padding: 120px 0;
    }
    @media (max-width: 899px) {
      padding: 90px 0;
    }
    @media (max-width: 599px) {
      padding: 60px 0;
    }
    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0px;
      top: 0px;
      background: linear-gradient(
        358.7deg,
        rgba(0, 0, 0, 0.7) 0.92%,
        rgba(0, 0, 0, 0) 184.3%
      );
      z-index: 1;
    }
    figure {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .banner_text {
      position: relative;
      z-index: 2;
      text-align: center;
      color: rgb(255, 255, 255);

      h1 {
        font-weight: 800;
        text-align: center;
        letter-spacing: -0.011em;
        color: inherit;
        span {
          display: block;
          font-weight: 600;
        }
      }
    }
    .banner_details_box {
      max-width: 661px;
      margin: 0 auto;
      p {
        font-size: 20px;
        margin-top: 20px;
      }
      .btnWrap {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 20px;
        margin-top: 54px;
        @media (max-width: 1199px) {
          margin-top: 20px;
          gap: 15px;
        }
        @media (max-width: 599px) {
          max-width: 320px;
          margin: 20px auto 0;
        }
        button {
          @media (max-width: 599px) {
            min-width: auto;
            width: 100%;
          }
        }
      }
    }
  }
`;
